module.exports = __webpack_public_path__ + "static/media/logo-sgu-name.293017b5.png";